const BOSNIAN_SPEAKING_COUNTRIES = ['BA', 'HR', 'RS', 'ME', 'SI'];

/**
 * Fetch a URL with a custom timeout.
 */
const fetchWithTimeout = async (url, options = {}, timeout = 5000) => {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);
  try {
    const response = await fetch(url, { ...options, signal: controller.signal });
    clearTimeout(id);
    return response;
  } catch (error) {
    clearTimeout(id);
    throw error;
  }
};

/**
 * Detect the country code of the user using geolocation APIs with fallbacks.
 * Returns a 2-letter ISO country code (uppercase) or null if all attempts fail.
 */
export const detectCountry = async () => {
  // Provider 1: free.freeipapi.com (Completely free, high rate limit, HTTPS, CORS-enabled)
  try {
    const res = await fetchWithTimeout('https://free.freeipapi.com/api/json');
    if (res.ok) {
      const data = await res.json();
      if (data && data.countryCode) {
        const country = data.countryCode.toUpperCase();
        console.log(`[Geolocation] Detected country via freeipapi: ${country}`);
        return country;
      }
    }
  } catch (e) {
    console.warn('[Geolocation] Primary API (freeipapi.com) failed, trying fallback...', e);
  }

  // Provider 2: ipapi.co (1,000 requests/day, HTTPS, CORS-enabled)
  try {
    const res = await fetchWithTimeout('https://ipapi.co/json/');
    if (res.ok) {
      const data = await res.json();
      if (data && data.country_code) {
        const country = data.country_code.toUpperCase();
        console.log(`[Geolocation] Detected country via ipapi.co: ${country}`);
        return country;
      }
    }
  } catch (e) {
    console.warn('[Geolocation] Secondary API (ipapi.co) failed, trying tertiary fallback...', e);
  }

  // Provider 3: api.country.is (Extremely simple, country-only detection, HTTPS, CORS-enabled)
  try {
    const res = await fetchWithTimeout('https://api.country.is/');
    if (res.ok) {
      const data = await res.json();
      if (data && data.country) {
        const country = data.country.toUpperCase();
        console.log(`[Geolocation] Detected country via country.is: ${country}`);
        return country;
      }
    }
  } catch (e) {
    console.error('[Geolocation] All geolocation APIs failed.', e);
  }

  return null;
};

/**
 * Determine target language ('bs' or 'en') based on the detected country code.
 */
export const getLanguageForCountry = (countryCode) => {
  if (!countryCode) return null;
  return BOSNIAN_SPEAKING_COUNTRIES.includes(countryCode) ? 'bs' : 'en';
};
